import { categories } from "@/mocks/opinion";

export default function CategorySection() {
  return (
    <section id="topic" className="bg-accent-950">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col items-start gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-secondary-300">
              <span className="h-px w-6 bg-secondary-400"></span> Topics
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-background-50">按话题看风向</h2>
            <p className="mt-3 max-w-xl text-sm md:text-base leading-relaxed text-background-200/80">
              挑一个你关心的领域，进入对应的观点长谈。每个分类都在持续沉淀热评与深度梳理。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 md:gap-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#read"
              className="group flex items-start gap-4 rounded-xl border border-background-200/15 bg-background-50/5 p-5 transition-colors hover:border-secondary-400/50 hover:bg-background-50/10"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-accent-950 transition-transform group-hover:scale-105">
                <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span>
                <span className="flex items-center justify-between">
                  <span className="font-heading text-base font-bold text-background-50">{c.name}</span>
                  <span className="ml-3 text-xs text-background-200/70">{c.count} 篇</span>
                </span>
                <span className="mt-1 block text-xs md:text-sm leading-relaxed text-background-200/80">{c.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}